<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">
    <!-- Header -->
    <app-account-header></app-account-header>

    <!-- Card -->
    <div class="card">
      <div class="card-header">

        <!-- Title -->
        <h4 class="card-header-title">
          Notifications
        </h4>

        <!-- Button -->
        <button class="btn btn-sm btn-white">
          Disable all
        </button>

      </div>
      <div class="table-responsive">
        <table class="table table-sm table-nowrap card-table">
          <thead>
          <tr>
            <th>Type</th>
            <th class="text-center">Call</th>
            <th class="text-center">Email</th>
            <th class="text-center">SMS</th>
          </tr>
          </thead>
          <tbody class="fs-base">
          <tr>
            <td>
              Direct messages
            </td>
            <td class="text-center"></td>
            <td class="text-center">

              <!-- Checkbox -->
              <div class="form-check d-inline-block me-n3">
                <input checked class="form-check-input" id="emailCheckboxOne" type="checkbox">
                <label class="form-check-label" for="emailCheckboxOne"></label>
              </div>

            </td>
            <td class="text-center">

              <!-- Checkbox -->
              <div class="form-check d-inline-block me-n3">
                <input checked class="form-check-input" id="smsCheckboxOne" type="checkbox">
                <label class="form-check-label" for="smsCheckboxOne"></label>
              </div>

            </td>
          </tr>
          <tr>
            <td>
              Reminders
            </td>
            <td class="text-center"></td>
            <td class="text-center">

              <!-- Checkbox -->
              <div class="form-check d-inline-block me-n3">
                <input checked class="form-check-input" id="emailCheckboxTwo" type="checkbox">
                <label class="form-check-label" for="emailCheckboxTwo"></label>
              </div>

            </td>
            <td class="text-center">

              <!-- Checkbox -->
              <div class="form-check d-inline-block me-n3">
                <input checked class="form-check-input" id="smsCheckboxTwo" type="checkbox">
                <label class="form-check-label" for="smsCheckboxTwo"></label>
              </div>

            </td>
          </tr>
          <tr>
            <td>
              API Limits
            </td>
            <td class="text-center">

              <!-- Checkbox -->
              <div class="form-check d-inline-block me-n3">
                <input class="form-check-input" id="callCheckboxThree" type="checkbox">
                <label class="form-check-label" for="callCheckboxThree"></label>
              </div>

            </td>
            <td class="text-center">

              <!-- Checkbox -->
              <div class="form-check d-inline-block me-n3">
                <input checked class="form-check-input" id="emailCheckboxThree" type="checkbox">
                <label class="form-check-label" for="emailCheckboxThree"></label>
              </div>

            </td>
            <td class="text-center">

              <!-- Checkbox -->
              <div class="form-check d-inline-block me-n3">
                <input checked class="form-check-input" id="smsCheckboxThree" type="checkbox">
                <label class="form-check-label" for="smsCheckboxThree"></label>
              </div>

            </td>
          </tr>
          <tr>
            <td>
              Policy & Community
            </td>
            <td class="text-center">

              <!-- Checkbox -->
              <div class="form-check d-inline-block me-n3">
                <input class="form-check-input" id="callCheckboxFour" type="checkbox">
                <label class="form-check-label" for="callCheckboxFour"></label>
              </div>

            </td>
            <td class="text-center">

              <!-- Checkbox -->
              <div class="form-check d-inline-block me-n3">
                <input checked class="form-check-input" id="emailCheckboxFour" type="checkbox">
                <label class="form-check-label" for="emailCheckboxFour"></label>
              </div>

            </td>
            <td class="text-center">

              <!-- Checkbox -->
              <div class="form-check d-inline-block me-n3">
                <input checked class="form-check-input" id="smsCheckboxFour" type="checkbox">
                <label class="form-check-label" for="smsCheckboxFour"></label>
              </div>

            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Card -->
    <div class="card">
      <div class="card-header">

        <!-- Title -->
        <h4 class="card-header-title">
          Subscriptions
        </h4>

        <!-- Button -->
        <button class="btn btn-sm btn-white">
          Unsubscribe all
        </button>

      </div>
      <div class="card-body">

        <!-- List group -->
        <div class="list-group list-group-flush my-n3">
          <div class="list-group-item">
            <div class="row align-items-center">
              <div class="col">

                <!-- Heading -->
                <h4 class="font-weight-base mb-1">
                  Sales & Promotions
                </h4>

                <!-- Small -->
                <small class="text-muted">
                  We only notify you for significant promotions
                </small>

              </div>
              <div class="col-auto">

                <!-- Switch -->
                <div class="form-check form-switch">
                  <input checked class="form-check-input" id="subscriptionsSwitchOne" type="checkbox">
                  <label class="form-check-label" for="subscriptionsSwitchOne"></label>
                </div>

              </div>
            </div> <!-- / .row -->
          </div>
          <div class="list-group-item">
            <div class="row align-items-center">
              <div class="col">

                <!-- Heading -->
                <h4 class="font-weight-base mb-1">
                  Product updates
                </h4>

                <!-- Small -->
                <small class="text-muted">
                  Major changes in our product offering
                </small>

              </div>
              <div class="col-auto">

                <!-- Switch -->
                <div class="form-check form-switch">
                  <input checked class="form-check-input" id="subscriptionsSwitchTwo" type="checkbox">
                  <label class="form-check-label" for="subscriptionsSwitchTwo"></label>
                </div>

              </div>
            </div> <!-- / .row -->
          </div>
          <div class="list-group-item">
            <div class="row align-items-center">
              <div class="col">

                <!-- Heading -->
                <h4 class="font-weight-base mb-1">
                  Newsletter
                </h4>

                <!-- Small -->
                <small class="text-muted">
                  Updates on what’s going on here at Landkit.
                </small>

              </div>
              <div class="col-auto">

                <!-- Switch -->
                <div class="form-check form-switch">
                  <input checked class="form-check-input" id="subscriptionsSwitchThree" type="checkbox">
                  <label class="form-check-label" for="subscriptionsSwitchThree"></label>
                </div>

              </div>
            </div> <!-- / .row -->
          </div>
        </div>

      </div>
    </div>

    <br>

  </div>
</div> <!-- / .row -->